import React, { useState } from 'react';
import './PricingFaqs.css'; // Import the CSS file

// Data for the FAQ items
const faqsData = [
  "How is MAU calculated?",
  "What is the difference between Starter, Pro, and Enterprise plans?",
  "What happens if I hit my MAU limit?",
  "How do I purchase higher levels of support?",
  "What other limits do I need to be aware of?",
  "Is every feature automatically included in the enterprise plan?",
  "Do the prices listed on the pricing page include tax?",
  "What's Sendbird pricing for Starter and Pro plans?",
  "Is the Sendbird Developer plan free forever?",
  "How do I cancel my Sendbird account?",
  "Can I switch payment methods?",
  "How can I obtain a copy of current or past invoices?",
  "Can I re-charge an invoice?",
  "How do I receive a payment link?",
  "How can I enter or update my credit card information?",
  "How can I upgrade or downgrade my account?",
  "How do I obtain US tax residency certificate information and forms?",
  "Where can I get a VAT tax ID number for invoices?",
  "What if I have additional questions about my invoice?"
];

/**
 * AccordionItem is a sub-component that manages its own open/close state.
 */
const AccordionItem = ({ title }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="accordion-item">
      <div className="accordion-title" onClick={() => setIsOpen(!isOpen)}>
        <span>{title}</span>
        {/* Using a proper minus sign (Unicode: U+2212) for a cleaner look */}
        <div className="accordion-icon">{isOpen ? '−' : '+'}</div>
      </div>
      {isOpen && (
        <div className="accordion-content">
          <p>
            Detailed answer information would be displayed here, providing more context to the user's question. This content can be customized for each FAQ item.
          </p>
        </div>
      )}
    </div>
  );
};


/**
 * The main PricingFaqs component.
 * It renders the layout, maps over the data to create accordion items,
 * and displays the call-to-action banner.
 */
const PricingFaqs = () => {
  return (
    <div className="faqs-container">
      <div className="faqs-content">
        <div className="faqs-title-section">
          <h2 className="faqs-title">
            Frequently <br />
            asked questions
          </h2>
        </div>
        <div className="faqs-accordion-section">
          {faqsData.map((faq, index) => (
            <AccordionItem key={index} title={faq} />
          ))}
        </div>
      </div>
      <div className="faqs-cta-section">
        <h3>Ready to improve customer communications?</h3>
        <button>Contact sales</button>
      </div>
    </div>
  );
};

export default PricingFaqs;